"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RunExecution = void 0;

var VerbosityLevel_1 = require("../configuration/VerbosityLevel");

var ExecutionStatus_1 = require("./ExecutionStatus");

var RunExecution = /*#__PURE__*/function () {
  function RunExecution(verbosity, interruptedAsFailure) {
    var _this = this;

    _classCallCheck(this, RunExecution);

    this.verbosity = verbosity;
    this.interruptedAsFailure = interruptedAsFailure;

    this.isSuccess = function () {
      return _this.pathToFailure == null;
    };

    this.firstFailure = function () {
      return _this.pathToFailure ? +_this.pathToFailure.split(':')[0] : -1;
    };

    this.numShrinks = function () {
      return _this.pathToFailure ? _this.pathToFailure.split(':').length - 1 : 0;
    };

    this.rootExecutionTrees = [];
    this.currentLevelExecutionTrees = this.rootExecutionTrees;
    this.failure = null;
    this.numSkips = 0;
    this.numSuccesses = 0;
    this.interrupted = false;
  }

  _createClass(RunExecution, [{
    key: "appendExecutionTree",
    value: function appendExecutionTree(status, value) {
      var currentTree = {
        status: status,
        value: value,
        children: []
      };
      this.currentLevelExecutionTrees.push(currentTree);
      return currentTree;
    }
  }, {
    key: "fail",
    value: function fail(value, id, message) {
      if (this.verbosity >= VerbosityLevel_1.VerbosityLevel.Verbose) {
        var currentTree = this.appendExecutionTree(ExecutionStatus_1.ExecutionStatus.Failure, value);
        this.currentLevelExecutionTrees = currentTree.children;
      }

      if (this.pathToFailure == null) this.pathToFailure = "".concat(id);else this.pathToFailure += ":".concat(id);
      this.value = value;
      this.failure = message;
    }
  }, {
    key: "skip",
    value: function skip(value) {
      if (this.verbosity >= VerbosityLevel_1.VerbosityLevel.VeryVerbose) {
        this.appendExecutionTree(ExecutionStatus_1.ExecutionStatus.Skipped, value);
      }

      if (this.pathToFailure == null) {
        ++this.numSkips;
      }
    }
  }, {
    key: "success",
    value: function success(value) {
      if (this.verbosity >= VerbosityLevel_1.VerbosityLevel.VeryVerbose) {
        this.appendExecutionTree(ExecutionStatus_1.ExecutionStatus.Success, value);
      }

      if (this.pathToFailure == null) {
        ++this.numSuccesses;
      }
    }
  }, {
    key: "interrupt",
    value: function interrupt() {
      this.interrupted = true;
    }
  }, {
    key: "extractFailures",
    value: function extractFailures() {
      if (this.isSuccess()) {
        return [];
      }

      var failures = [];
      var cursor = this.rootExecutionTrees;

      while (cursor.length > 0 && cursor[cursor.length - 1].status === ExecutionStatus_1.ExecutionStatus.Failure) {
        var failureTree = cursor[cursor.length - 1];
        failures.push(failureTree.value);
        cursor = failureTree.children;
      }

      return failures;
    }
  }, {
    key: "toRunDetails",
    value: function toRunDetails(seed, basePath, maxSkips, qParams) {
      if (!this.isSuccess()) {
        return {
          failed: true,
          interrupted: this.interrupted,
          numRuns: this.firstFailure() + 1 - this.numSkips,
          numSkips: this.numSkips,
          numShrinks: this.numShrinks(),
          seed: seed,
          counterexample: this.value,
          counterexamplePath: RunExecution.mergePaths(basePath, this.pathToFailure),
          error: this.failure,
          failures: this.extractFailures(),
          executionSummary: this.rootExecutionTrees,
          verbose: this.verbosity,
          runConfiguration: qParams.toParameters()
        };
      }

      var failed = this.numSkips > maxSkips || this.interrupted && this.interruptedAsFailure;
      return {
        failed: failed,
        interrupted: this.interrupted,
        numRuns: this.numSuccesses,
        numSkips: this.numSkips,
        numShrinks: 0,
        seed: seed,
        counterexample: null,
        counterexamplePath: null,
        error: null,
        failures: [],
        executionSummary: this.rootExecutionTrees,
        verbose: this.verbosity,
        runConfiguration: qParams.toParameters()
      };
    }
  }]);

  return RunExecution;
}();

exports.RunExecution = RunExecution;

RunExecution.mergePaths = function (offsetPath, path) {
  if (offsetPath.length === 0) return path;
  var offsetItems = offsetPath.split(':');
  var remainingItems = path.split(':');
  var middle = +offsetItems[offsetItems.length - 1] + +remainingItems[0];
  return [].concat(_toConsumableArray(offsetItems.slice(0, offsetItems.length - 1)), ["".concat(middle)], _toConsumableArray(remainingItems.slice(1))).join(':');
};